module.exports = __webpack_public_path__ + "static/media/dotsBg.7c382217.png";